// TermsOfService.jsx
import React from "react";
import "./styles/PrivacyPolicy.scss"; // Reuse the same PrivacyPolicy styles

const TermsOfService = () => {
  return (
    <div className="privacy-policy">
      <h1>Terms of Service</h1>
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using our website and services, you agree to comply
          with and be bound by these Terms of Service. If you do not agree, you
          may not use our services.
        </p>
      </section>

      <section>
        <h2>2. Donations</h2>
        <p>
          Donations made through our website are processed via PayPal. By making
          a donation, you acknowledge that you are authorized to use the payment
          method provided. All donations are final and non-refundable unless
          otherwise required by applicable law.
        </p>
      </section>

      <section>
        <h2>3. Use of Content</h2>
        <p>
          All content on our website, including text, images, and logos, is
          owned by the Del Couch Music Education Foundation or its licensors.
          Unauthorized use of this content is prohibited.
        </p>
      </section>

      <section>
        <h2>4. Disclaimer of Warranties</h2>
        <p>
          Our services are provided "as is" and "as available" without any
          warranties of any kind. We do not guarantee that our website will be
          uninterrupted, error-free, or secure.
        </p>
      </section>

      <section>
        <h2>5. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, the Del Couch Music Education
          Foundation is not liable for any indirect, incidental, or
          consequential damages arising from your use of our services.
        </p>
      </section>

      <section>
        <h2>6. Changes to Terms</h2>
        <p>
          We reserve the right to update or modify these Terms of Service at any
          time. Changes will be posted on this page with an updated revision
          date.
        </p>
      </section>

      <section>
        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about these Terms of Service, please refer to the contact us page. 
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
